import { User } from "../interface";
import { api } from "../api";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function getUser(uid: number): Promise<User | null> {
    if (!api.userApi) {
        return null;
    }

    return api.userApi.usersRead(uid).then((response) => {
        if (response instanceof Error || (response.message && response.message.error)) {
            if (response instanceof Error) {
                HelperSrc.writeLog("error", response);
            } else {
                store.doNotice(lang[response.message.error]);
            }
        }

        return response as unknown as User;
    });
}

export { getUser };
